<template>
  <div>
    <div v-if="pumpkinStatus === `normal`" class="pumpkin" @click="clickPumpkin">
      <img class="pumpkin__image" src="@/assets/practices/pumpkin_clock/pumpkin.png" alt="pumpkin" />
      <h1 class="pumpkin__time">{{ pumpkinTime }}</h1>
    </div>
    <div v-else-if="pumpkinStatus" class="pumpkin">
      <img class="pumpkin__image" src="@/assets/practices/pumpkin_clock/pumpkin_happy.png" alt="pumpkin_happy" />
      <img class="pumpkin__bubble" src="@/assets/practices/pumpkin_clock/bubble_correct.svg" alt="bubble_correct" />
    </div>
    <div v-else-if="!pumpkinStatus" class="pumpkin">
      <img class="pumpkin__image" src="@/assets/practices/pumpkin_clock/pumpkin_sad.png" alt="pumpkin_sad" />
      <img class="pumpkin__bubble" src="@/assets/practices/pumpkin_clock/bubble_incorrect.svg" alt="bubble_incorrect" />
    </div>
  </div>
</template>

<script>
import { setTimeout } from 'timers';
// import { Howl } from 'howler';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Pumpkin',
  // eslint-disable-next-line vue/require-default-prop
  props: { pumpkinTime: String, pumpkinAnswer: Boolean },
  data: () => ({
    pumpkinStatus: 'normal',
  }),
  methods: {
    checkPumpkinAnswer() {
      if (this.pumpkinAnswer) {
        sounds.pumpkinClockCorrectAnswer.play();
        this.$store.state.pumpkinClock.answerStatus = true;
        this.pumpkinStatus = true;
        this.$store.state.pumpkinClock.playerScore += 300;
        setTimeout(() => {
          this.$store.state.pumpkinClock.explanationStatus = true;
          this.$store.state.pumpkinClock.correctStatus = true;
          this.$confetti.start({
            defaultSize: 10,
            particlesPerFrame: 0.15,
            particles: [
              {
                type: 'rect',
              },
              {
                type: 'circle',
              },
              {
                type: 'image',
                size: 70,
                url: '/assets/practices/global/confetti/correct_nerd.svg',
              },
            ],
          });
          this.pumpkinStatus = 'normal';
          this.$store.state.pumpkinClock.answerStatus = false;
          this.checkGameOver();
        }, 3000);
      } else {
        sounds.pumpkinClockIncorrectAnswer.play();
        this.$store.state.pumpkinClock.answerStatus = true;
        this.pumpkinStatus = false;
        this.$store.state.pumpkinClock.currentLives -= 1;
        setTimeout(() => {
          this.$store.state.pumpkinClock.explanationStatus = true;
          this.$confetti.start({
            defaultSize: 10,
            particlesPerFrame: 0.1,
            defaultDropRate: 10,
            particles: [
              {
                type: 'image',
                size: 20,
                dropRate: 5,
                url: '/assets/practices/global/confetti/incorrect_cross_heavy.svg',
              },
              // {
              //   type: 'image',
              //   size: 80,
              //   url: '/assets/practices/global/confetti/incorrect_tired.svg',
              // },
            ],
          });
          this.pumpkinStatus = 'normal';
          this.$store.state.pumpkinClock.answerStatus = false;
        }, 3000);
      }
    },
    checkGameOver() {
      if (
        (this.$store.state.pumpkinClock.exerciseCompleted && this.$store.state.pumpkinClock.currentLives <= 0) ||
        (this.$store.state.pumpkinClock.exerciseCompleted && this.$store.state.pumpkinClock.currentExercise >= 4)
      ) {
        this.$store.state.pumpkinClock.gameCompleted = true;
      }
    },
    clickPumpkin() {
      sounds.globalButton.play();
      if (this.$store.state.pumpkinClock.answerStatus) {
        console.log('You have already selected an option.');
      } else {
        this.checkPumpkinAnswer();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.pumpkin {
  @include flex-center;
  font-family: 'VanillaExtractRegular';
  cursor: pointer;

  .pumpkin__image {
    height: 33vh;
    width: 38vh;
  }

  .pumpkin__bubble {
    position: absolute;
    height: 17.5vh;
    animation: bubble-pop-up 3s forwards;
    opacity: 0;
  }

  .pumpkin__time {
    position: absolute;
    z-index: 2;
    color: $pumpkin-clock-color-main;
    font-size: 10vh;
    transform: translateY(-3.5vh);
  }
}

@keyframes bubble-pop-up {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  25% {
    opacity: 1;
    transform: translateY(-20vh);
  }
  100% {
    opacity: 1;
    transform: translateY(-20vh);
  }
}

@media (max-aspect-ratio: 8/5) {
  .pumpkin {
    .pumpkin__image {
      height: 32vh;
      width: 35vh;
    }

    .pumpkin__time {
      font-size: 8vh;
    }
  }
}
</style>
